import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/flaticon.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.css";
import "./assets/css/slick-theme.css";
import "./assets/css/jquery.fancybox.css";
import "./assets/css/style.css";
import "bootstrap/js/src/collapse.js";
import reportWebVitals from "./reportWebVitals";
import { Main } from "./Main";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
